/** Keep a link only when it points into this instance: relative, or the same
 *  origin. Model-written markdown is rendered through this, because the model
 *  reads whatever the store holds and a link is where an injected instruction
 *  would try to carry data out. An outside or scripted address becomes ''. */
export function sameOriginUrl(url: string): string {
  const trimmed = url.trim();
  if (trimmed === '') return '';
  if (/^(javascript|data|vbscript):/i.test(trimmed)) return '';
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) || trimmed.startsWith('//')) {
    try {
      const target = new URL(trimmed, window.location.origin);
      return target.origin === window.location.origin ? target.href : '';
    } catch {
      return '';
    }
  }
  return trimmed;
}
